<div class="review-display-container" [class.hidden]="!isActive">
    <div class="ui basic segment">
        <!--Save button-->
        <a (click)="onBack()" class="back-button">
            <mat-icon svgIcon="chevronLeft" [matTooltip]="'back' | translate"></mat-icon>
            {{ 'back' | translate }}
        </a>
        <div class="toolkit">
            <!--Autosave-->
            <div class="flex justify-center margin-bottom-2">
                <app-autosave-info [lastSaved]="autosave"></app-autosave-info>
            </div>

            <div class="profile">
                <app-avatar [employee]="review.subject" size="profile"></app-avatar>
                <h3 class="header">{{ review.subject.firstName }} {{ review.subject.lastName }}</h3>
            </div>
            <mat-divider class="margin-top-4 margin-bottom-3"></mat-divider>
            <div class="profile-table">
                <div (click)="changeTab('fields')" [class.active]="tab === 'fields'">
                    <span class="label">{{ 'performance.show.reviewResultsLabel' | translate }}</span>
                </div>
                <div (click)="changeTab('goals')" [class.active]="tab === 'goals'">
                    <span class="label">{{ 'performance.show.goalsCompletedLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getGoalsBadgeType()">
                            {{
                                'performance.show.goalsPill'
                                    | translate
                                        : {
                                              goalsComplete: (goals | filter: 'isComplete' : true)?.length,
                                              goalsLength: goals.length,
                                          }
                            }}
                        </ui-badge>
                    </div>
                </div>
                <div (click)="changeTab('feedback-received')" [class.active]="tab === 'feedback-received'">
                    <span class="label">{{ 'performance.show.feedbackReceivedLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getFeedbackBadgeType(feedbackReceived.length)">
                            {{ feedbackReceived.length }}
                        </ui-badge>
                    </div>
                </div>
                <div (click)="changeTab('feedback-given')" [class.active]="tab === 'feedback-given'">
                    <span class="label">{{ 'performance.show.feedbackGivenLabel' | translate }}</span>
                    <div class="badge-container">
                        <ui-badge [type]="getFeedbackBadgeType(feedbackGiven.length)">
                            {{ feedbackGiven.length }}
                        </ui-badge>
                    </div>
                </div>
                <ui-button
                    class="submit-button"
                    size="full-width"
                    [disabled]="!isComplete()"
                    (click)="submit()"
                    type="primary"
                >
                    {{ 'performance.show.submitReview' | translate }}
                </ui-button>
            </div>
        </div>

        <form class="form fields">
            <h2 class="header">{{ review.title }}</h2>
            <span>{{ review.description }}</span>

            <mat-divider class="margin-top-3"></mat-divider>

            <div class="period-header">
                {{
                    'performance.show.reviewPeriodDescription'
                        | translate
                            : {
                                  reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                  reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                              }
                }}
            </div>

            <ng-template [ngIf]="tab === 'fields'">
                <ui-card
                    *ngFor="let field of fields; let index = index; trackBy: trackByFn"
                    class="field toolkit-item"
                    [attr.arr-index]="index"
                    [attr.field-index]="field.index"
                >
                    <div class="card-label font-medium">
                        {{ 'performance.show.questionCardTitle' | translate: { index: index + 1 } }}
                        <ui-badge *ngIf="field.isOptional && performanceReviewImprovements" class="optional-badge">{{
                            'performance.show.optional' | translate
                        }}</ui-badge>
                    </div>
                    <label class="question-label" [innerHTML]="field.question | nl2br | sanitizeHtml"></label>

                    <ng-template [ngIf]="field.type === 'freeform'">
                        <textarea
                            class="freeform-text"
                            name="question-{{ field.index }}"
                            (blur)="triggerAutoSave(false)"
                            (ngModelChange)="triggerAutoSave(true)"
                            [(ngModel)]="jsonResponse['question' + field.index]"
                        ></textarea>
                    </ng-template>

                    <ng-template [ngIf]="field.type === 'multiple'">
                        <div class="grouped fields">
                            <div
                                *ngFor="let choice of field.choices; let choiceIndex = index; let first = first"
                                class="field"
                            >
                                <div
                                    class="ui radio checkbox"
                                    [attr.data-value]="choiceIndex"
                                    [attr.data-model]="'question' + field.index"
                                >
                                    <input type="radio" name="question-{{ field.index }}" />
                                    <label>{{ choice }}</label>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="field.type === 'rating'">
                        <div
                            class="ui massive star rating"
                            [attr.data-rating]="jsonResponse['question' + field.index]"
                            data-max-rating="10"
                            [attr.data-model]="'question' + field.index"
                        ></div>
                        <div class="rating-labels">
                            <span>{{ 'performance.templates.lowRating' | translate }}</span>
                            <span>{{ 'performance.templates.highRating' | translate }}</span>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="field.type === 'scale'">
                        <div class="agree-disagree-scale" [attr.data-model]="'question' + field.index">
                            <div data-value="0">
                                <mat-icon svgIcon="stronglyDisagree"></mat-icon>
                                <div [innerHTML]="'performance.templates.stronglyDisagree' | translate"></div>
                            </div>
                            <div data-value="1">
                                <mat-icon svgIcon="somewhatDisagree"></mat-icon>
                                <div [innerHTML]="'performance.templates.somewhatDisagree' | translate"></div>
                            </div>
                            <div data-value="2">
                                <mat-icon svgIcon="neitherAgreeNorDisagree"></mat-icon>
                                <div [innerHTML]="'performance.templates.neitherAgreeNorDisagree' | translate"></div>
                            </div>
                            <div data-value="3">
                                <mat-icon svgIcon="somewhatAgree"></mat-icon>
                                <div [innerHTML]="'performance.templates.somewhatAgree' | translate"></div>
                            </div>
                            <div data-value="4">
                                <mat-icon svgIcon="stronglyAgree"></mat-icon>
                                <div [innerHTML]="'performance.templates.stronglyAgree' | translate"></div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template [ngIf]="field.type === 'boolean'">
                        <div class="true-false-scale" [attr.data-model]="'question' + field.index">
                            <div data-value="0">
                                <mat-icon svgIcon="thumbDown"></mat-icon>
                                <div class="label">{{ 'performance.templates.noDisagree' | translate }}</div>
                            </div>
                            <div data-value="1">
                                <mat-icon svgIcon="thumbUp"></mat-icon>
                                <div class="label">{{ 'performance.templates.yesAgree' | translate }}</div>
                            </div>
                        </div>
                    </ng-template>
                </ui-card>
            </ng-template>

            <ng-template [ngIf]="tab === 'goals'">
                <h3 class="tab-header">
                    {{
                        'performance.show.goalsHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>

                <div class="goals-info-container padding-top-3">
                    <ng-template ngFor let-goal [ngForOf]="goals">
                        <div class="box-1">
                            <div class="font-medium">{{ goal.title }}</div>
                            <div>
                                {{
                                    'performance.show.dueAt'
                                        | translate: { goalDueAt: goal.dueAt | appDate: 'mediumDate' }
                                }}
                            </div>
                            <div>
                                <ui-badge [type]="goal.dueIn <= 0 ? 'warning' : 'danger'">
                                    <i *ngIf="goal.metricType === 'percent'" class="icon percent"></i>
                                    <i *ngIf="goal.metricType === 'dollar'" class="icon dollar"></i>
                                    <i *ngIf="goal.metricType === 'binary'" class="icon checkmark"></i>
                                    <i *ngIf="goal.metricType === 'number'" class="icon hashtag"></i>
                                    {{
                                        'performance.show.goalsPill'
                                            | translate
                                                : { goalsComplete: goal.currentValue, goalsLength: goal.metricValue }
                                    }}
                                </ui-badge>
                            </div>
                        </div>
                        <div class="box-2 margin-bottom-3">
                            <ui-badge *ngIf="goal.isComplete" type="success">{{
                                'performance.show.complete' | translate
                            }}</ui-badge>
                            <ui-badge *ngIf="!goal.isComplete" type="danger">{{
                                'performance.show.incomplete' | translate
                            }}</ui-badge>
                        </div>
                        <div class="box-3">
                            <div
                                class="ui progress"
                                [attr.data-value]="goal.currentValue"
                                [attr.data-total]="goal.metricValue"
                            >
                                <div class="bar">
                                    <div class="progress"></div>
                                </div>
                            </div>
                            <div [innerHTML]="goal.description | sanitizeHtml" class="font-medium"></div>
                            <mat-divider class="margin-top-3 margin-bottom-3"></mat-divider>
                        </div>
                    </ng-template>
                </div>
                <p *ngIf="!goals.length">{{ 'performance.show.noGoals' | translate }}</p>
            </ng-template>

            <ng-template [ngIf]="tab === 'feedback-received'">
                <h3 class="tab-header">
                    {{
                        'performance.show.feedbackReceivedHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>
                <div class="feedback-info">
                    <ng-template ngFor let-comment [ngForOf]="feedbackReceived">
                        <div class="box-1">
                            <div>
                                <app-avatar [employee]="comment.creator" [name]="true"></app-avatar>
                            </div>
                            <div class="font-medium">{{ comment.createdAt | appDate: 'mediumDate' }}</div>
                            <div class="font-medium">{{ comment.visibility }}</div>
                            <div>
                                <mat-icon *ngIf="comment.positive" svgIcon="stronglyAgree"></mat-icon>
                                <mat-icon *ngIf="comment.constructive" svgIcon="neitherAgreeNorDisagree"></mat-icon>
                                <mat-icon *ngIf="comment.negative" svgIcon="stronglyDisagree"></mat-icon>
                            </div>
                        </div>
                        <mat-divider class="margin-top-3"></mat-divider>
                        <div class="font-medium">{{ comment.title }}</div>
                        <div [innerHTML]="comment?.body | sanitizeHtml"></div>
                    </ng-template>
                </div>
                <p *ngIf="!feedbackReceived?.length">{{ 'performance.show.noFeedbackReceived' | translate }}</p>
            </ng-template>

            <ng-template [ngIf]="tab === 'feedback-given'">
                <h3 class="tab-header">
                    {{
                        'performance.show.feedbackGivenHeader'
                            | translate
                                : {
                                      reviewStartDate: review.periodStart | appDate: 'mediumDate',
                                      reviewEndDate: review.periodEnd | appDate: 'mediumDate',
                                  }
                    }}
                </h3>

                <div class="feedback-info">
                    <ng-template ngFor let-comment [ngForOf]="feedbackGiven">
                        <div class="box-1">
                            <div>
                                <app-avatar [employee]="comment.subject" [name]="true"></app-avatar>
                            </div>
                            <div class="font-medium">{{ comment.createdAt | appDate: 'mediumDate' }}</div>
                            <div class="font-medium">{{ comment.visibility }}</div>
                            <div>
                                <mat-icon *ngIf="comment.positive" svgIcon="stronglyAgree"></mat-icon>
                                <mat-icon *ngIf="comment.constructive" svgIcon="neitherAgreeNorDisagree"></mat-icon>
                                <mat-icon *ngIf="comment.negative" svgIcon="stronglyDisagree"></mat-icon>
                            </div>
                        </div>
                        <mat-divider class="margin-top-3"></mat-divider>
                        <div class="font-medium">{{ comment.title }}</div>
                        <div [innerHTML]="comment?.body | sanitizeHtml"></div>
                    </ng-template>
                </div>
                <p *ngIf="!feedbackGiven?.length">{{ 'performance.show.noFeedbackGiven' | translate }}</p>
            </ng-template>
        </form>
    </div>
</div>
